import React, { useState } from 'react';
import GradesRequest from 'pages/Products/components/GradesRequest';
import Heading from 'components/Heading';
import CustomTabs from 'components/CustomTabs';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import CategoryTab from './components/CategoryTab';
import { PRODUCT_TABS_HEADING } from './constant';
import ProductTab from './components/ProductTab';
import SubCategory from './components/SubCategory';

const Products = () => {
  const [activeTab, setActiveTab] = useState(PRODUCT_TABS_HEADING.CATEGORY);
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <div className="products-page">
      <div className="mb-3 pb-1 top-head">
        <Heading title="Products" />
      </div>

      <Card className="border-0 card-box page-card-box">
        <CardBody>
          <CustomTabs
            tabs={[
              PRODUCT_TABS_HEADING.CATEGORY,
              PRODUCT_TABS_HEADING.PRODUCT,
              PRODUCT_TABS_HEADING.SUBCATEGORY,
              PRODUCT_TABS_HEADING.GRADE,
            ]}
            selectedTab={activeTab}
            onTabChange={toggle}
            className="mb-2"
            // className="border-0"
          />
          <TabContent activeTab={activeTab}>
            <TabPane tabId={PRODUCT_TABS_HEADING.CATEGORY}>
              {activeTab === PRODUCT_TABS_HEADING.CATEGORY && <CategoryTab />}
            </TabPane>
            <TabPane tabId={PRODUCT_TABS_HEADING.PRODUCT}>
              {activeTab === PRODUCT_TABS_HEADING.PRODUCT && <ProductTab />}
            </TabPane>
            <TabPane tabId={PRODUCT_TABS_HEADING.SUBCATEGORY}>
              {activeTab === PRODUCT_TABS_HEADING.SUBCATEGORY && (
                <SubCategory />
              )}
            </TabPane>
            <TabPane tabId={PRODUCT_TABS_HEADING.GRADE}>
              {activeTab === PRODUCT_TABS_HEADING.GRADE && <GradesRequest />}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </div>
  );
};

export default Products;
